import * as Sentry from "@sentry/react";

let initialized = false;
let enabled = false;

function parseSampleRate(value, fallbackValue = 0) {
  const parsed = Number.parseFloat(String(value ?? "").trim());
  if (Number.isFinite(parsed) && parsed >= 0 && parsed <= 1) {
    return parsed;
  }
  return fallbackValue;
}

function initFrontendSentry() {
  if (initialized) return enabled;
  initialized = true;

  const dsn = String(import.meta.env.VITE_SENTRY_DSN || "").trim();
  if (!dsn) {
    enabled = false;
    return false;
  }

  Sentry.init({
    dsn,
    environment: String(
      import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE || "development",
    ).trim(),
    tracesSampleRate: parseSampleRate(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE, 0),
  });

  enabled = true;
  return true;
}

function captureFrontendError(error, context = {}) {
  if (!initialized) initFrontendSentry();
  if (!enabled) return;

  const safeError =
    error instanceof Error ? error : new Error(String(error || "Unknown frontend error"));

  Sentry.withScope((scope) => {
    const component = String(context.component || "").trim();
    if (component) scope.setTag("react.component", component);

    const details =
      context.errorInfo && typeof context.errorInfo === "object"
        ? context.errorInfo
        : context.details && typeof context.details === "object"
          ? context.details
          : null;
    if (details) scope.setContext("details", details);

    Sentry.captureException(safeError);
  });
}

export { captureFrontendError, initFrontendSentry };
